# chat dummy
Sofatutor.chatDummy =
  timeouts: []
  start: (el, actors, entries, subject, isTyping, delay) ->
    @destroy()
    @el = el
    @actors = actors
    @isTyping = isTyping
    @inner = $('.inner', @el)
    @input = $('.input-inner', @el)
    @entries = entries.slice(0)
    @subject = subject
    @timeouts[0] = setTimeout($.proxy(->
      @append()
    , this), delay or 0)

  destroy: ->
    @entries = null
    $.each @timeouts, (i, timeout) ->
      clearTimeout timeout if timeout

    @timeouts = []
    if @el
      @inner.html ''
      @input.html '<span>|</span>'

  append: ->
    entry = @entries.shift()
    if typeof entry.delay is 'undefined'
      if entry.actor is 2
        entry.delay = entry.text.length * 50 + 500
        entry.delay = 4000 if entry.delay > 4000
      else
        entry.delay = 1500
    if entry.actor is 1
      @timeouts[1] = setTimeout($.proxy(->
        input = @input
        $.each entry.text.split(''), $.proxy((i, letter) ->
          @timeouts[i + 2] = setTimeout(->
            input.find('span').remove()
            input.html input.html() + letter + '<span>|</span>'
          , 80 * i)
        , this)
        @timeouts[entry.text.length + 2] = setTimeout($.proxy(->
          input.find('span').remove()
          @inner.append '<div class=\'student\'>' + '<span class=\'name\'>' + @actors[entry.actor - 1] + ':</span>' + input.html() + '</div>'
          input.html '<span>|</span>'
          @append()
        , this), 80 * (entry.text.length - 1) + 1000)
      , this), entry.delay)
    else
      @timeouts[1] = setTimeout($.proxy(->
        @inner.append '<div class=\'teacher\'>' + '<span class=\'name\'>' + @actors[entry.actor - 1] + ':</span><span class=\'typing\'>' + @isTyping + '</span>' + '</div>'
        @timeouts[1] = setTimeout($.proxy(->
          el = $('div', @inner).last()
          el.find('.typing').remove()
          el.html el.html() + entry.text
          @append()
        , this), entry.delay)
      , this), 1000)
